import { render, staticRenderFns } from "./DmDownloadMatchStatus.vue?vue&type=template&id=be02a9ca&scoped=true&"
import script from "./DmDownloadMatchStatus.vue?vue&type=script&lang=js&"
export * from "./DmDownloadMatchStatus.vue?vue&type=script&lang=js&"
import style0 from "./DmDownloadMatchStatus.vue?vue&type=style&index=0&id=be02a9ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be02a9ca",
  null
  
)

export default component.exports